
import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  { id: 'home', label: 'الرئيسية', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', path: '/home' },
  { id: 'services', label: 'الخدمات', icon: 'ri-apps-line', activeIcon: 'ri-apps-fill', path: '/services' },
  { id: 'orders', label: 'الطلبات', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill', path: '/orders' },
  { id: 'profile', label: 'الحساب', icon: 'ri-user-line', activeIcon: 'ri-user-fill', path: '/profile' },
];

export default function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-50">
      <div className="grid grid-cols-4 h-16">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-1 transition-all"
            >
              <div className={`w-6 h-6 flex items-center justify-center ${isActive ? 'text-[#1565C0]' : 'text-gray-400'}`}>
                <i className={`${isActive ? tab.activeIcon : tab.icon} text-xl`}></i>
              </div>
              <span className={`text-[10px] ${isActive ? 'text-[#1565C0] font-semibold' : 'text-gray-400'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
